<script
  setup
  lang="ts"
  generic="ExtraBase extends BaseMenu, ExtraBaseButton extends BaseMenu, ExtraBaseSubmenu extends BaseMenu"
>
import UIMenu from './Menu.vue';
import UIItem from './Item.vue';
import UISubItem from './SubItem.vue';
import UISubMenuBase from './SubMenuBase.vue';
import {
  type BaseMenu, type MenuTheme, type ItemBaseMenu, theme as themeTailwind,
} from '../types';

withDefaults(
  defineProps<{
    items: ItemBaseMenu<
      ExtraBase,
      ExtraBaseButton,
      ExtraBaseSubmenu
    >[],
    theme?: MenuTheme,
    selected?: string,
  }>(),
  { theme: () => themeTailwind },
);
</script>
<template>
  <UIMenu :theme="theme">
    <template
      v-for="item in items"
      :key="item.key"
    >
      <UISubMenuBase
        v-if="'submenu' in item"
        :item="item"
        :selected="selected"
        :theme-sub-menu-item="theme.subMenuItem"
        :theme-sub-menu="theme.subMenu"
      >
        <!-- @vue-ignore -->
        <template #[`item_${item.key}`]="args">
          <slot name="menu_title" v-bind="{ ...args, item: item as ExtraBaseButton }" />
        </template>
        <!-- @vue-ignore -->
        <template #[`sub_menu_${item.key}`]="{ submenu }">
          <template
            v-for="subitem in submenu"
            :key="subitem.key"
          >
            <UISubItem
              :classes="theme.subMenuItem"
              :selected="selected === subitem.key"
            >
              <template #default="args">
                <slot
                  name="submenu_item"
                  v-bind="{ item: item as ExtraBaseButton, subitem: subitem as ExtraBaseSubmenu, ...args }"
                />
              </template>
            </UISubItem>
          </template>
        </template>
      </UISubMenuBase>
      <UIItem
        v-else
        v-slot="args"
        :class="theme.li.class"
        :focusable="theme.li.focusable"
        :selected="selected === item.key"
      >
        <slot name="menu_base" v-bind="{ item: item as ExtraBase, ...args }" />
      </UIItem>
    </template>
  </UIMenu>
</template>
